import React, { useEffect, useState } from 'react';
import { analyticsTrackEvent } from '../../../core/analytics';
import { ACTION_CHANGE_VALUE, UNIVERSAL_VACCINE_INPUT } from '../../../core/analytics/events';
import DropdownInput from './inputs/DropdownInput';
import { FieldDisplayProps } from './inputs/Field';

type Props = { onChange: (vaccine: string) => void } & Omit<FieldDisplayProps, 'label'>;

/**
 * Dropdown input for the homepage search to select adult or child.
 */
const VaccineInput = ({ onChange, ...rest }: Props) => {
  const [vaccineType, setVaccineType] = useState('any');

  const options = [
    {
      label: 'Any',
      value: 'any',
    },
    {
      label: 'Moderna',
      value: 'moderna',
    },
    {
      label: 'Pfizer',
      value: 'pfizer',
    },
    {
      label: 'J&J',
      value: 'jnj',
    },
  ];

  useEffect(() => {
    onChange(vaccineType);
    analyticsTrackEvent(UNIVERSAL_VACCINE_INPUT, {
      action: ACTION_CHANGE_VALUE,
      vaccine: vaccineType,
    });
  }, [onChange, vaccineType]);

  return (
    <DropdownInput
      label="Vaccine Type"
      onChange={setVaccineType}
      options={options}
      trackingLabel={UNIVERSAL_VACCINE_INPUT}
      value={vaccineType}
      {...rest}
    />
  );
};

export default VaccineInput;
